import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { axiosPrivate } from 'app/utils';

import type { PlusWebsitesResponse } from './usePlusWebsites';

const queryKey = ['plus-websites'];

export type PublishWebsiteResult = UseMutationResult<AxiosResponse<unknown>, Error, string>;

export function usePublishWebsite(): PublishWebsiteResult {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (websiteId: string) =>
      axiosPrivate.post(`/v3/pharmacist/plus-websites/${websiteId}/versions/published`),
    onSuccess: (_data, websiteId) => {
      queryClient.setQueriesData<AxiosResponse<PlusWebsitesResponse>>({ queryKey }, (old) =>
        old
          ? {
              ...old,
              data: {
                ...old.data,
                plusWebsites: old.data.plusWebsites.map((website) =>
                  website.id === websiteId ? { ...website, hasUnpublishedChanges: false } : website
                ),
              },
            }
          : old
      );
    },
    meta: {
      successMessage: 'Website published successfully',
      errorMessage: 'Failed to publish website',
    },
  });
}
